import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import * as React from 'react';
import { callOptional } from '../helpers/function.js';

var useFocused = function useFocused() {
  var initialState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var onFocusProp = arguments.length > 1 ? arguments[1] : undefined;
  var onBlurProp = arguments.length > 2 ? arguments[2] : undefined;

  var _React$useState = React.useState(initialState),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      focused = _React$useState2[0],
      setFocused = _React$useState2[1];

  var onFocus = React.useCallback(function (e) {
    setFocused(true);
    callOptional(onFocusProp)(e);
  }, [onFocusProp, setFocused]);
  var onBlur = React.useCallback(function (e) {
    setFocused(false);
    callOptional(onBlurProp)(e);
  }, [onBlurProp, setFocused]);
  return {
    focused: focused,
    onFocus: onFocus,
    onBlur: onBlur,
    setFocused: setFocused
  };
};

export { useFocused };
